import { FC, useCallback, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import AsyncSelect from 'react-select/async'
import debounce from 'debounce'

interface Option {
  value: string
  label: string
}
type InputProps = {
  loadOptions?: any
  keySelect?: string
  name?: string
  value?: Option | null
  onChangeValue?: (e: any) => void
  disabled?: boolean
  textPlaceholder?: string
}
const customStyles = {
  control: (provided: any) => ({
    ...provided,
    minWidth: '200px',
  }),
  menuPortal: (provided: any) => ({
    ...provided,
    zIndex: 9999,
  }),
}
const SelectAsyncComponent: FC<InputProps> = ({
  keySelect = null,
  name = '',
  disabled,
  onChangeValue,
  loadOptions,
  value = null,
  textPlaceholder = 'Escribe...',
  ...props
}) => {
  const { control, formState: { errors } } = useFormContext()
  const [isLoading, setIsLoading] = useState(false);
  const debouncedLoadOptions = useCallback(
    debounce((inputValue: string, callback: (options: Option[]) => void) => {
      setIsLoading(true)
      loadOptions(inputValue).then((options: Option[]) => {
        callback(options)
        setIsLoading(false)
      }).catch(() => setIsLoading(false))
    }, 1500),
    [loadOptions]
  )

  return (
    <div className='sdx_form_input '>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <AsyncSelect
            {...field}
            key={keySelect ?? field.value}
            // cacheOptions
            defaultOptions
            loadOptions={debouncedLoadOptions} // usar la versión con debounce
            classNamePrefix='react-select'
            noOptionsMessage={() => 'No hay resultados'}
            menuPortalTarget={document.body}
            placeholder={textPlaceholder}
            styles={{ ...customStyles }}
            value={value}
            onChange={(val: any) => {
              if (onChangeValue) onChangeValue(val)
            }}
            isDisabled={disabled}
            isLoading={isLoading}
          />
        )}
      />
      {errors[name] && <p>{errors[name]?.message?.toString()}</p>}
    </div>
  )
}

export default SelectAsyncComponent
